module.exports = __webpack_public_path__ + "static/media/sleep-basics-large.2a36bc76.png";